import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionService } from 'src/app/features/subscription/subscription.service';
import { RegistrationService } from '../../../registration.service';

import { UrlParamsService } from 'src/app/shared/services/url-params.service';
import { ProgressBarMode, MatProgressBarModule } from '@angular/material/progress-bar';
import { PublicMeetingDTO } from '../../../types/PublicMeetingDTO';
import { PublicOnlineMeetingDTO } from '../../../types/PublicOnlineMeetingDTO';

@Component({
  selector: 'app-online-confirmation',
  imports: [MatProgressBarModule],
  templateUrl: './online-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './online-confirmation.component.scss',
})
export class OnlineConfirmationComponent {
  meetingInfo: PublicOnlineMeetingDTO | null = null;
  progressValue = 0;
  timerInterval: any;
  onlineMeetingUrl: string = '';
  noUrl: boolean = false;
  showProgressBar: boolean = true;

  constructor(
    private registrationService: RegistrationService,
    private urlParamsService: UrlParamsService
  ) {}

  ngOnInit(): void {
    this.registrationService.onlineMeetingInfo$.subscribe({
      next: (meetingInfo) => {
        this.meetingInfo = meetingInfo;

        const state = history.state;
        if (state && state.onlineMeetingUrl) {
          this.onlineMeetingUrl = state.onlineMeetingUrl;
        }

        if (this.onlineMeetingUrl === 'Meeting URL not available yet.') {
          this.noUrl = true;
        }

        this.startProgressBar();
      },
      error: (error) => {
        console.error('Error fetching meeting info:', error);
      },
    });
  }

  startProgressBar(): void {
    let progress = 0;
    this.timerInterval = setInterval(() => {
      if (progress < 100) {
        progress += 2;
        this.progressValue = progress;
      } else {
        clearInterval(this.timerInterval);
        this.redirectToMeeting();
      }
    }, 100);
  }

  cancelRedirect(): void {
    clearInterval(this.timerInterval);
    this.showProgressBar = false;
  }

  redirectToMeeting(): void {
    if (!this.noUrl) {
      window.location.href = this.onlineMeetingUrl;
    }
  }
}
